import { PaymentSystemsEnum } from '@utils/types';

import { OperationNextEnum } from '@modules/types';

export type Redirect3DSResponse = {
  requestType: string;
  uriTemplate: string;
  form: { [key in 'key' | 'template' | 'value']: string }[];
};

export enum CardBindStatusesEnum {
  pending = 'pending',
  succeeded = 'succeeded',
  failed = 'failed',
  deleted = 'deleted',
}

// cards

export type GETCardsResponse = {
  id: string;
  created_at: string;
  payment_system: PaymentSystemsEnum | null;
  card_number: string;
  card_expiration_month: string;
  card_expiration_year: string;
  bank?: {
    title: string;
    color: {
      background: string;
      foreground: string;
    };
    icon: string;
  };
  issued_by_mercuryo?: boolean;
};

// cards/bind

export type POSTCardsBindParams = {
  holder_name: string;
  number: string;
  cvv: string;
  expiration_month: string;
  expiration_year: string;
  zh_agree?: boolean;
};

export type POSTCardsBindResponse = {
  id: string;
  status: string;
  next?: OperationNextEnum;
  redirect?: Redirect3DSResponse;
};

// cards/:id/bind-status

export type GETCardsBindStatusResponse = {
  id: string;
  status: CardBindStatusesEnum;
  redirect?: Redirect3DSResponse;
};

// cards/:id/delete

export type POSTCardsDeleteParams = {
  id: string;
};

// flutterwave/validate

export type FlutterWaveValidateParams = {
  payment_id: string;
  otp: string;
};

export type FlutterWaveValidateResponse = {
  result: string;
  redirect?: Redirect3DSResponse;
};
